<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p style="text-indent:0px;"><em>Writing this book was harder than I thought and more rewarding than I could have ever imagined. I had to step away from it several times because of the nature of the true events involved within its writing. This book includes explicit true events from 1942 Warsaw, Poland. None of this would have been possible without my husband, Dean Slone, and his support and belief in this project, allowing me to disappear in my office for hours on end. Thank you to Allan Adair and Erin Kazee for your wonderful help and supportive editing advice. You guys have been my ‘offsite’ editors.</em></p><br/>
<p style="text-indent:0px;"><em>This book has been written in the course of one year. Many months at my Puerto Rico home as well as my home in Ohio. I want to thank all my friends in both places for their love and inspiration.</em></p><br/>
<p style="text-indent:0px;"><em>For all of my friends and family.</em></p><br/>
<p style="text-indent:0px;"><em>Find my author page, ‘Gregory Hudson Books’ on Facebook.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?5a796a11